// utils/axios.js
import axios from 'axios';
import API_URL from '../config';

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

apiClient.interceptors.request.use(
  config => {
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };
    const csrfToken = getCookie('csrf_access_token');
    if (csrfToken) {
      config.headers['X-CSRF-TOKEN'] = csrfToken;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Reuse the existing refresh endpoint once for concurrent expired requests.
let refreshPending = null;
apiClient.interceptors.response.use(response => response, async error => {
  const request = error.config;
  if (error.response?.data?.code === 'session_revoked') {
    window.dispatchEvent(new Event('session-ended'));
    return Promise.reject(error);
  }
  const csrf = typeof document === 'undefined' ? null : document.cookie.split(';')
    .map(value => value.trim()).find(value => value.startsWith('csrf_refresh_token='))?.split('=').slice(1).join('=');
  if (error.response?.status !== 401 || !request || request._sessionRetried || !csrf) {
    return Promise.reject(error);
  }
  request._sessionRetried = true;
  if (!refreshPending) {
    refreshPending = axios.post(`${API_URL}/auth/token/refresh`, {}, {
      withCredentials: true, headers: { 'X-CSRF-TOKEN': csrf },
    }).finally(() => { refreshPending = null; });
  }
  try {
    await refreshPending;
    return apiClient.request(request);
  } catch (refreshError) {
    if (refreshError.response?.status === 401) window.dispatchEvent(new Event('session-ended'));
    return Promise.reject(refreshError);
  }
});

export default apiClient;
